"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "erba": {
    "123eeb2f": [{
      "hkey": "b54554bb",
      "slug": "erba",
      "name": "Erba",
      "primary": true,
      "skipSearch": false
    }],
    "arcellasco": [{
      "hkey": "b54554bb",
      "slug": "erba",
      "name": "Erba",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "814b6c45": [{
      "hkey": "b54554bb",
      "slug": "erba",
      "name": "Erba",
      "primary": true,
      "skipSearch": false
    }],
    "buccinigo": [{
      "hkey": "b54554bb",
      "slug": "erba",
      "name": "Erba",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6f656999": [{
      "hkey": "b54554bb",
      "slug": "erba",
      "name": "Erba",
      "primary": true,
      "skipSearch": false
    }],
    "cassina-mariaga": [{
      "hkey": "b54554bb",
      "slug": "erba",
      "name": "Erba",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b5f6bef5": [{
      "hkey": "b54554bb",
      "slug": "erba",
      "name": "Erba",
      "primary": true,
      "skipSearch": false
    }],
    "crevenna": [{
      "hkey": "b54554bb",
      "slug": "erba",
      "name": "Erba",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "10ed82f3": [{
      "hkey": "b54554bb",
      "slug": "erba",
      "name": "Erba",
      "primary": true,
      "skipSearch": false
    }],
    "incino": [{
      "hkey": "b54554bb",
      "slug": "erba",
      "name": "Erba",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "240a3d68": [{
      "hkey": "b54554bb",
      "slug": "erba",
      "name": "Erba",
      "primary": true,
      "skipSearch": false
    }],
    "parravicino": [{
      "hkey": "b54554bb",
      "slug": "erba",
      "name": "Erba",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;